var API = {
  URL_QUEUE_ORIGIN: 'https://eu-west-1.queue.amazonaws.com',
  URL_QUEUE_VS: 'https://eu-west-1.queue.amazonaws.com/678300112051/UR-PRODUCTION',
  // URL_CDN_USERREPORT: 'https://cdn.userreport.com',
};